const { now } = require("underscore");

$(function () {

    // INITIALIZE DATEPICKER PLUGIN
    $('.datepicker').datepicker({
      //  clearBtn: true,
        autoclose:true,
        startDate: "tomorrow",
        endDate: '+31d',
        datesDisabled: '+31d',
        format: "mm/dd/yyyy",
    }).datepicker('update', new Date());


    // FOR DEMO PURPOSE
    $('#reservationDate').on('change', function () {
        var pickedDate = $(this).val();
        $('#pickedDate').html(pickedDate);
    });
});